// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3lJia","colCheckbox":"styles_colCheckbox__1Ecoa"};